import React from 'react';
import {
    StyledTabContentContianer,
    TabContent,
    TabContentFont,
    TabSelectedBorder,
} from './AccountDetailTab.styled';
const AccountDetailTabList = ({ label, isTabActive, tabSwitch, id, isJapanUser }) => {
    return (
        <>
            <StyledTabContentContianer
                onClick={() => {
                    tabSwitch(id);
                }}
                isSelected={isTabActive}
                cursor={'pointer'}
            >
                <TabContent isPending={false} isBatch={false}>
                    <TabContentFont isSelected={isTabActive} isJapanUser={isJapanUser}>
                        {label}
                    </TabContentFont>
                </TabContent>
                <TabSelectedBorder isSelected={isTabActive} />
            </StyledTabContentContianer>
        </>
    );
};

export default AccountDetailTabList;